import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    auth: {
      token: false
    },
    appState: {
      SnackbarMsg: {
        text: '',
        color: 'success',
        show: false,
        timeout: 2000
      },
      DialogConfirmAction: {
        title: '',
        msg: '',
        color: 'success',
        show: false,
        status: undefined,
        action: undefined
      }
    }
  },
  mutations: {
    setSnackbarMsg (state, item) {
      console.log('setSnackbarMsg :: ', item)
      state.appState.SnackbarMsg = item
    },
    setDialogConfirmAction (state, item) {
      console.log('setDialogConfirmAction :: ', item)
      state.appState.DialogConfirmAction = item
    },
    setAuth (state, item) {
      console.log('setAuth :: ', item)
      state.auth = item
    }
  },
  actions: {

  },
  getters: {

  }
})
